import React from 'react';
import moment from 'moment';
import {Button, Col, Row} from "react-bootstrap";

import Page from "../component/Page/Page";
import Notify from "../services/Notify";
import BeaconService from "./beacon/BeaconService";
import Loading from "../component/Loading/Loading";
import Box from "../component/Box/Box";
import Objects from "../utils/Objects";
import BoxTableWithPagination from "../component/Box/BoxTableWithPagination";
import BeaconSelector from "./beacon/BeaconSelector";
import HttpRequest from "../services/HttpRequest";
import {dayMonthYearAtTime} from "../utils/dates";
import {DateRangeSelector} from '../component/Date/DateRangeSelector';


class BluzonePage extends React.Component {

  service = new BeaconService();

  constructor(props) {
    super(props);

    this.state = {
      filter: {}, 
      url: null,
      beginDate: moment().set({ hour: 0, minute: 0, second: 0 }).toDate(),
      endDate: moment().set({ hour: 23, minute: 59, second: 59 }).toDate()
    };
  }

  componentDidMount() {
    this.applyFilter();
  }

  onChangePolicy(event) {
    const {filter = {}} = this.state;
    filter['policy'] = event;
    this.setState({filter});
  }

  onChangeBeacon(event) {
    const {filter = {}} = this.state;
    filter['beacon'] = event;
    this.setState({filter});
    this.applyFilter();
  }

  applyFilter() {
    console.log('update url');
    this.setState({url: this.getUrl()})
  }

  getUrl() {
    const { beginDate, endDate, filter} = this.state;

    if (Objects.isNullOrUndefined(beginDate)) {
      return '';
    }

    const beacon = filter.beacon;
    return `integration/v1/policy-events?dateBegin=${beginDate.toISOString()}&dateEnd=${endDate.toISOString()}${beacon ? '&_beaconId=' + beacon.id : ''}`
  }

  render() {
    const {url} = this.state;

    return (
        <Page>
          <form>
            <Row>
              <Col sm={2}>
                <DateRangeSelector 
                  onChange={(beginDate, endDate) => this.setState({ beginDate, endDate })}
                />
              </Col>
              <Col sm={3}>
                <BeaconSelector onChange={this.onChangeBeacon.bind(this)}/>
              </Col>
              <Col sm={2}>
                <Button bsStyle="success" onClick={() => this.applyFilter()} style={{marginTop: '12%'}} block> Buscar </Button>
              </Col>
            </Row>
          </form>
          <Box info title="Ultima Localização">
            {this.getLastCheckout()}
          </Box>
          <BoxTableWithPagination title="Eventos"
                                  onDataLoad={(data) => this.setState({data, showStatus: true})}
                                  url={url} columns={<tr>
            <th>Beacon</th>
            <th>Política</th>
            <th>Data/Hora</th>
            <th>Status</th>
          </tr>} bodyRender={policy => (policy && <tr key={policy.id}>
            <td>{policy.beacon && policy.beacon.name}</td>
            <td>{policy.policy && policy.policy.name}</td>
            <td>{dayMonthYearAtTime(policy.timestamp)}</td>
            <td>{policy.newState === 'VIOLATING' ? 'Check-In' : 'Check-Out'}</td>
          </tr>)}/>
        </Page>
    );
  }

  getLastCheckout() {

    const {data = {}, filter, loading, showStatus = null} = this.state;
    const lastCheckpoint = data.content && data.content.filter(x => x.newState === 'OK' && (x.policy.id !== '5c6feefe4c142900015c757e'))[0];

    if (Objects.isNullOrUndefined(filter.beacon)) {
      return <h3>Selecione um beacon, para validar o status</h3>
    }

    if (showStatus === null) {
      return;
    }

    if (Objects.isNullOrUndefined(lastCheckpoint)) {
      return <h2>Sem checkpoint válido</h2>
    }

    if (loading) {
      return <Loading message="Salvando..."/>
    }

    if (showStatus === false) {
      return <h3> O status foi salvo!</h3>
    }

    return <Row>

      <Col sm={4}>
        <label>Caçamba: </label><h3 style={{fontSize: 22}}>{filter.beacon.name}</h3>
        <label>Local origem: </label><h3 style={{fontSize: 22}}>{lastCheckpoint.policy.name}</h3>
        <h3 style={{fontSize: 14}}>Data/hora: {dayMonthYearAtTime(lastCheckpoint.timestamp)}</h3>
      </Col>
      <Col sm={1}>
        <Button block bsStyle="primary" onClick={() => this.addPolicyEventStatus(lastCheckpoint, true)}>Tudo certo</Button>
      </Col>
      <Col sm={1}>
        <Button block bsStyle="secondary" onClick={() => this.addPolicyEventStatus(lastCheckpoint, false)}>Incorreto</Button>
      </Col>
    </Row>
  }

  addPolicyEventStatus(policyEvent, allRight) {
    this.setState({loading: true});
    new HttpRequest().post(`integration/v1/policy-events/${policyEvent.id}/status/${allRight ? 'true' : 'false'}`).then(
        () => {
          this.setState({showStatus: false, loading: false});
          Notify.success('Registro confirmado com sucesso!')
        }, error => {
          Notify.error('Falha ao salvar status do evento', error);
          this.setState({loading: false});
        }
    )
  }
}

export default BluzonePage;



// WEBPACK FOOTER //
// ./src/bluzone/BluzonePage.js